import type {MenuItem} from "~/types";

export const useMenu = () => {
  const {role} = useProducerSessionAdm()

  const consumerMenuItems: MenuItem[] = [
    {title: 'Meus Dados', link: '/minha-conta/meus-dados', icon: 'mdi:user', activeMenu: 'info'},
    {title: 'Meus Ingressos', link: '/minha-conta/meus-ingressos', icon: 'tdesign:ticket', activeMenu: 'my-tickets'},
    {title: 'Lista de desejos', link: '/minha-conta/lista-desejos', icon: 'material-symbols:favorite-outline', activeMenu: 'wishlist'},
    {title: 'Área do Produtor', link: '/produtor', icon: 'hugeicons:manager', activeMenu: 'producer'}
  ]

  const PRODUCER_MENU_ITEMS: MenuItem[] = [
    {title: 'Criar Evento', link: '/produtor/eventos/adicionar', activeMenu: 'add-event'},
    {title: 'Meus Dados', link: '/produtor/meus-dados', activeMenu: 'producer-info'},
    {title: 'Página do Produtor', link: '/produtor/pagina-produtor', activeMenu: 'producer-page'},
    {title: 'Meus Eventos', link: '/produtor/eventos', activeMenu: 'producer-events'},
    {title: 'Colaboradores', link: '/produtor/colaboradores', activeMenu: 'team-users'}
  ]

  const producerMenuItens = computed(() => {
    if (role.value === 'CHECK_IN') {
      return PRODUCER_MENU_ITEMS.filter(i => i.activeMenu === 'producer-events')
    } else {
      return PRODUCER_MENU_ITEMS
    }
  })

  return {producerMenuItens, consumerMenuItems}

}
